import * as React from "react";
import { SVGProps } from "react";

const KeepNetwork = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65" {...props}>
    <path d="M32.5 0C14.6 0 0 14.6 0 32.5S14.6 65 32.5 65 65 50.4 65 32.5 50.4 0 32.5 0zm13.6 25.2h-2l-6.2 7.2 6.2 7.2h2v5.8H33v-5.8h2L30.9 35h-1.7v4.8h2.3v5.8H18.8v-5.8h2.8V25.3h-2.8v-5.8H22v2.2h1.7v-2.2h3.1v2.2h1.7v-2.2h3.1v5.7h-2.3V30H31l4.1-4.8h-2v-5.7h13.2l-.2 5.7z" />
  </svg>
);

export default KeepNetwork;
